export interface AddGenericStreamFormData {
  id: string | null;
  name: string;
  description?: string;
  categoryId?: string[];
  status: GenericStreamStatus;
  type: GenericStreamType;
  connectedStreamIds: string[];
  llmId: string;
  dateCreate?: number;
  dateUpdate?: number;
  creatingUserId?: string;
  creatingUserPrename?: string;
  creatingUserLastname?: string;
  updatingUserPrename?: string;
  updatingUserLastname?: string;
  updatingUserId?: string;
  streamGoal: string;
  promotionArea: PromotionAreaObject
}

export interface PromotionAreaObject {
  status: boolean;
  imgStatus: boolean | null;
  imgUrl: string | null;
  headline: string | null;
  description: string | null;
  targetUrl: string | null;
  videos: VideoObject[];
}
export interface GenericStream extends AddGenericStreamFormData {
  credits: number;
  duration: number;
  globalStream: boolean;
  steps?: GenericStepConfig[];
  streamResults: StreamClosingResult[];
}
export interface VideoObject {
  url: string;
  thumbnail: string;
  title: string;
  description: string;
}
export enum GenericStreamStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  PENDING = 'pending',
  EXPERIMENTAL = 'experimental'
}
export enum GenericStreamType {
  PROFESSIONAL = "professional",
  BASIC = "basic",
  FREE = "free",
}



export interface GenericStepConfigList {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
}
export interface GenericStepConfig {
  id: string;
  name: string;
  description: string;
  duration: number;
  credits: number;
  websearchStatus: boolean;
  websearch?: WebsearchQuestion[]
  uploadStatus: boolean;
  upload?: {
    resultPrompt: string;
  }
  agentId: string | null;
  agentPrompt: string;
  closingPromptId: string;
  keyQuestions: KeyQuestion[];
  stepGoal: string;
  requiredStepIds: string[]; // Default all

}
export interface StreamClosingResult {
  orderNumber: number;
  title: string;
  type: StreamClosingType['id'];
}
export interface WebsearchQuestion {
  title: string
  query: string;
  description: string
  source: string;
}
export interface KeyQuestion {
  title: string;
  question: string;
  description: string;
}
export interface StreamClosingType {
  id: string;
  name: string;
}

export interface EditingStreamObject {
  id: string;
  userId: string;
  userName: string;
  time: number;
}
export interface TokenUsageByStream {
  streamTypeId: string;
  stepId: string;
  llmId: string;
  totalPromptTokens: number;
  totalResponseTokens: number;
  totalTokens: number;
  streamName: string;
  stepName: string;
  groupCount: number;
}
